import React, { createContext, useContext, useState, useEffect } from "react";

export interface SelectedCustomerContextType {
  selectedCustomer: any | null;
  setSelectedCustomer: (customer: any | null) => void;
}

const SelectedCustomerContext = createContext<SelectedCustomerContextType>({
  selectedCustomer: null,
  setSelectedCustomer: () => {},
});

export const SelectedCustomerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedCustomer, setSelectedCustomerState] = useState<any | null>(
    null
  );

  // Al montar, leer de localStorage
  useEffect(() => {
    const stored = localStorage.getItem("selectedCustomer");
    if (stored) {
      try {
        setSelectedCustomerState(JSON.parse(stored));
      } catch {}
    }
  }, []);

  // Al cambiar, guardar en localStorage
  const setSelectedCustomer = (customer: any | null) => {
    setSelectedCustomerState(customer);
    if (customer) {
      localStorage.setItem("selectedCustomer", JSON.stringify(customer));
    } else {
      localStorage.removeItem("selectedCustomer");
    }
  };

  return (
    <SelectedCustomerContext.Provider
      value={{ selectedCustomer, setSelectedCustomer }}
    >
      {children}
    </SelectedCustomerContext.Provider>
  );
};

export const useSelectedCustomer = () => useContext(SelectedCustomerContext);
